import {
  JsonConfiguration2bv2x41u8reet as JsonConfiguration,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance6cczsnt45hfi as ClassDiscriminatorMode_POLYMORPHIC_getInstance,
} from './JsonConfiguration.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DescriptorSchemaCache22yqwocbp420v as DescriptorSchemaCache } from './internal/SchemaCache.mjs';
import { JsonToStringWriter25agxcyem0yhk as JsonToStringWriter } from './internal/JsonToStringWriterJsWasm.mjs';
import { encodeByWriter108llwage8l5s as encodeByWriter } from './internal/JsonStreams.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { WriteMode_OBJ_getInstance1vaoooqbofom8 as WriteMode_OBJ_getInstance } from './internal/WriteMode.mjs';
import { StreamingJsonDecoderyo05rsghf9i6 as StreamingJsonDecoder } from './internal/StreamingJsonDecoder.mjs';
import { writeJson2mc74ohxvvl1i as writeJson } from './internal/TreeJsonEncoder.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { JsonSerializersModuleValidator1v682i122jgoa as JsonSerializersModuleValidator } from './internal/JsonSerializersModuleValidator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Json() {
      constructor() {
        Default_instance = null;
        super(new (JsonConfiguration())(), EmptySerializersModule());
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var JsonClass;
function Json() {
  if (JsonClass === VOID) {
    class $ {
      constructor(configuration, serializersModule) {
        Default_getInstance();
        this.configuration_1 = configuration;
        this.serializersModule_1 = serializersModule;
        this._schemaCache_1 = new (DescriptorSchemaCache())();
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeToString_k0apqx_k$(serializer, value) {
        var result = new (JsonToStringWriter())();
        try {
          encodeByWriter(this, result, serializer, value);
          return result.toString();
        }finally {
          result.release_wu5yyf_k$();
        }
      }
      decodeFromString_jwu9sq_k$(deserializer, string) {
        var lexer = StringJsonLexer(this, string);
        var input = new (StreamingJsonDecoder())(this, WriteMode_OBJ_getInstance(), lexer, deserializer.get_descriptor_wjt6a0_k$(), null);
        var result = input.decodeSerializableValue_xpnpad_k$(deserializer);
        lexer.expectEof_2xwqoj_k$();
        return result;
      }
      encodeToJsonElement_w5lo4o_k$(serializer, value) {
        return writeJson(this, value, serializer);
      }
    }
    initMetadataForClass($, 'Json');
    JsonClass = $;
  }
  return JsonClass;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new (JsonBuilder())(from);
  builderAction(builder);
  var conf = builder.build_bkh6qh_k$();
  return new (JsonImpl())(conf, builder.serializersModule_1);
}
var JsonBuilderClass;
function JsonBuilder() {
  if (JsonBuilderClass === VOID) {
    class $ {
      constructor(json) {
        this.encodeDefaults_1 = json.configuration_1.encodeDefaults_1;
        this.explicitNulls_1 = json.configuration_1.explicitNulls_1;
        this.ignoreUnknownKeys_1 = json.configuration_1.ignoreUnknownKeys_1;
        this.isLenient_1 = json.configuration_1.isLenient_1;
        this.prettyPrint_1 = json.configuration_1.prettyPrint_1;
        this.prettyPrintIndent_1 = json.configuration_1.prettyPrintIndent_1;
        this.coerceInputValues_1 = json.configuration_1.coerceInputValues_1;
        this.classDiscriminator_1 = json.configuration_1.classDiscriminator_1;
        this.classDiscriminatorMode_1 = json.configuration_1.classDiscriminatorMode_1;
        this.useAlternativeNames_1 = json.configuration_1.useAlternativeNames_1;
        this.namingStrategy_1 = json.configuration_1.namingStrategy_1;
        this.decodeEnumsCaseInsensitive_1 = json.configuration_1.decodeEnumsCaseInsensitive_1;
        this.allowTrailingComma_1 = json.configuration_1.allowTrailingComma_1;
        this.allowComments_1 = json.configuration_1.allowComments_1;
        this.allowSpecialFloatingPointValues_1 = json.configuration_1.allowSpecialFloatingPointValues_1;
        this.allowStructuredMapKeys_1 = json.configuration_1.allowStructuredMapKeys_1;
        this.useArrayPolymorphism_1 = json.configuration_1.useArrayPolymorphism_1;
        this.serializersModule_1 = json.get_serializersModule_piitvg_k$();
        this.exceptionsWithDebugInfo_1 = json.configuration_1.exceptionsWithDebugInfo_1;
      }
      build_bkh6qh_k$() {
        if (this.useArrayPolymorphism_1) {
          // Inline function 'kotlin.require' call
          if (!(this.classDiscriminator_1 === 'type')) {
            var message = 'Class discriminator should not be specified when array polymorphism is specified';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!this.classDiscriminatorMode_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
            var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
          }
        }
        if (!this.prettyPrint_1) {
          // Inline function 'kotlin.require' call
          if (!(this.prettyPrintIndent_1 === '    ')) {
            var message_1 = 'Indent should not be specified when default printing mode is used';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
          }
        } else if (!(this.prettyPrintIndent_1 === '    ')) {
          var tmp0 = this.prettyPrintIndent_1;
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(tmp0)) {
              var element = charSequenceGet(tmp0, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
                tmp$ret$6 = false;
                break $l$block;
              }
            }
            tmp$ret$6 = true;
          }
          var allWhitespaces = tmp$ret$6;
          // Inline function 'kotlin.require' call
          if (!allWhitespaces) {
            var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.prettyPrintIndent_1;
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_2));
          }
        }
        return new (JsonConfiguration())(this.encodeDefaults_1, this.ignoreUnknownKeys_1, this.isLenient_1, this.allowStructuredMapKeys_1, this.prettyPrint_1, this.explicitNulls_1, this.prettyPrintIndent_1, this.coerceInputValues_1, this.useArrayPolymorphism_1, this.classDiscriminator_1, this.allowSpecialFloatingPointValues_1, this.useAlternativeNames_1, this.namingStrategy_1, this.decodeEnumsCaseInsensitive_1, this.allowTrailingComma_1, this.allowComments_1, this.classDiscriminatorMode_1, this.exceptionsWithDebugInfo_1);
      }
    }
    initMetadataForClass($, 'JsonBuilder');
    JsonBuilderClass = $;
  }
  return JsonBuilderClass;
}
function validateConfiguration($this) {
  if (equals($this.get_serializersModule_piitvg_k$(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new (JsonSerializersModuleValidator())($this.configuration_1);
  $this.get_serializersModule_piitvg_k$().dumpTo_vt5sm4_k$(collector);
}
var JsonImplClass;
function JsonImpl() {
  if (JsonImplClass === VOID) {
    class $ extends Json() {
      constructor(configuration, module_0) {
        super(configuration, module_0);
        validateConfiguration(this);
      }
    }
    initMetadataForClass($, 'JsonImpl');
    JsonImplClass = $;
  }
  return JsonImplClass;
}
//region block: exports
export {
  Default_getInstance as Default_getInstancevb13yk0g3h3e,
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion

//# sourceMappingURL=Json.mjs.map
